import { h } from 'preact';
import { missingTitle, duplicateTitle, missingReleaseDate, duplicateSlug, validateSlug, missingSlug, urlValidationError } from 'utils/errors';

import AddMovieModal from 'components/movies/addMovieModal/addMovieModal';

export default class FocusAddMovieModal extends AddMovieModal {
	get fields() {
		return {
			title: { render: this.renderTitleField, validators: [missingTitle, duplicateTitle] },
			release: { render: this.renderReleaseDateField, validators: [missingReleaseDate] },
			slug: { render: this.renderSlugField, validators: [missingSlug, duplicateSlug, validateSlug] },
			url: { render: this.renderExternalUrlField, validators: [urlValidationError] },
		};
	}

	getNewMovieOptions() {
		return this.state.data;
	}
}
